import moment from 'moment';
import React from 'react';
import { useLoad } from '../../collection/Hooks';
import Loading from '../../collection/icons/Loading';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';

export default function VacacionesModal(props) {
    const isNew = props.idVacaciones < 1;

    const updateData = async () => await apiGet("vacaciones/get/" + props.idVacaciones);

    const checkData = formData => {
        let errors = {};
        // Trabajador
        if (props.super) {
            const trabajador = formData.get("trabajador");
            if (!trabajador) {
                errors["trabajador"] = "Campo obligatorio";
            }
        }
        // Fecha inicio
        const fechaInicio = formData.get("fechaInicio");
        if (!fechaInicio) {
            errors["fechaInicio"] = "Campo obligatorio";
        }
        // Fecha fin
        const fechaFin = formData.get("fechaFin");
        if (!fechaFin) {
            errors["fechaFin"] = "Campo obligatorio";
        }
        // Ano
        const ano = formData.get("ano");
        const year = moment().year();
        if (!ano || !Number.isInteger(+ano)) {
            errors["ano"] = "Número no válido";
        }
        // Comentar o eliminar para poder pedir vacaciones usando días del año siguiente
        else if (+ano > year) {
            errors["ano"] = "Año no elegible";
        }

        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("vacaciones/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevas vacaciones" : "Editar vacaciones"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            {props.super ? <VacacionesFormSuper permisoAdmin={props.permisoAdmin} /> : <VacacionesForm />}
        </BsModalForm>
    );
}

function VacacionesForm(props) {
    const data = props.data;
    const errors = props.errors;
    return <>
        <BsFormControl
            /* Fecha inicio */
            label="Inicio" name="fechaInicio"
            value={data.fechaInicio} error={errors.fechaInicio}
            type="date" />
        <BsFormControl
            /* Fecha fin */
            label="Final" name="fechaFin"
            value={data.fechaFin} error={errors.fechaFin}
            className="mt-3" type="date" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
        <BsFormControl
            /* Año */
            label="Año" name="ano" help="Año laboral del que se descuentan los días de vacaciones"
            value={data.ano ? data.ano : moment().format("YYYY")} error={errors.ano}
            className="mt-3" type="number" />
    </>;
}

function VacacionesFormSuper(props) {
    const data = props.data;
    const errors = props.errors;
    const [userList, reload] = useLoad(async () => { return await apiGet(props.permisoAdmin ? "usuarios/list" : "usuarios/listtrabajadores") });

    return userList ? <>
        <BsFormSelect
            /* Trabajador */
            label="Trabajador" name="trabajador"
            value={data.trabajador} error={errors.trabajador}
            options={userList} />
        <BsFormControl
            /* Fecha inicio */
            label="Inicio" name="fechaInicio"
            value={data.fechaInicio} error={errors.fechaInicio}
            type="date" className="mt-3" />
        <BsFormControl
            /* Fecha fin */
            label="Final" name="fechaFin"
            value={data.fechaFin} error={errors.fechaFin}
            className="mt-3" type="date" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
        <BsFormControl
            /* Año */
            label="Año" name="ano" help="Año laboral del que se descuentan los días de vacaciones"
            value={data.ano ? data.ano : moment().format("YYYY")} error={errors.ano}
            className="mt-3" type="number" />
    </> : <Loading />;
}
